import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import { openOutInApp, openURIInApp, compareVersions } from '../../utils/URLSchemeHelper'

const TransferModal = ({ themeName, closeTransferModal, appVersion }) => {
  const intl = useIntl()
  const locale = intl.locale
  const navigate = useNavigate()
  const { stationId } = useParams()

  const station = () => {
    return MasterData.station(Number(stationId))
  }

  useEffect(() => {
    return () => {
      closeTransferModal()
    }
  }, [])

  const handleCloseClick = (e) => {
    navigate(-1)
  }

  // 上部の青いヘッダー
  const renderHeader = () => {
    return (
      <div className={`c-Modal-header is_${themeName}`}>
        <p className="c-Modal-headerTitle">
          <FormattedMessage id='App.TransferModal.transferRoute' />
        </p>
        <div className="c-Modal-headerClose" onClick={handleCloseClick}></div>
      </div>
    )
  }

  // 他社乗り換え路線表示
  const renderTransfers = () => {
    const allTransfers = station().transfers
    const transferItems = allTransfers.filter(transfer =>
      !transfer.minAppVersion ||
      (appVersion && compareVersions(appVersion, transfer.minAppVersion) >= 0)
    )
    return(
      <div className="c-Modal-body">
        <div className="c-Modal-station">
          {transferItems.map((transfer) => renderTransferCompany(transfer))}
        </div>
      </div>
    )
  }

  // 乗換路線の会社一覧表示
  const renderTransferCompany = (transfer) => {
    return (
      <div key={Math.random()}>
        <div className="c-Modal-stationHeader">
          <div className={`is_${transfer.icon} c-Modal-stationImg`}></div>
          {transfer[`name_${locale}`]}
        </div>
        <ul className="c-Modal-stationList">
          {transfer.lines.map((line) => renderTransferLine(line))}
        </ul>
      </div>
    )
  }

  // 乗換路線を表示
  const renderTransferLine = (line) => {
    const handleClick = () => {
      if (line.url) {
        openURIInApp(encodeURIComponent(line.url))
      } else {
        openOutInApp(line.query)
      }
    }

    return (
      <li key={Math.random()} className="c-Modal-stationItem">
        <a href="#" className="c-Modal-stationItemAnchor" onClick={handleClick}>
          <div className={`is_${line.icon} c-Modal-stationImg`}></div>
          {line[`name_${locale}`]}
        </a>
      </li>
    )
  }
  
  return (
    <div className="c-Modal">
      <div className="c-Modal-dialog">
        {renderHeader()}
        {renderTransfers()}
      </div>
    </div>
  )
}

TransferModal.propTypes = {
  themeName: PropTypes.string.isRequired,
  closeTransferModal: PropTypes.func.isRequired,
  appVersion: PropTypes.string,
}

export default TransferModal
